import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IApiBase } from './Interface/IApiBase.interface';
import { CatalogPaginationRequest } from '../../models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from '../../models/Filter/FilterRequest';
import { UserTokenRequest } from 'src/app/features/pages/authmanagement/models/user-token-request.model';
import { IEstatusJson } from 'src/app/features/pages/authmanagement/models/IEstatusJson';

@Injectable({
  providedIn: 'root'
})
export class UserTokenAPIService implements IApiBase{

  constructor(private http: HttpClient) {}
  insert() {
    throw new Error('Method not implemented.');
  }
  update(datos: any) {
    throw new Error('Method not implemented.');
  }
  delete(id: any) {
    throw new Error('Method not implemented.');
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error('Method not implemented.');
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }

  isValidToken(userToken: UserTokenRequest){
    return this.http.post<IEstatusJson>(environment.host + '/api/UserToken/IsValidToken', userToken);
  }
}